import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import UserList from '../pages/user/view/UserList';
import UserDetail from '../pages/user/view/UserDetail';
import UserCreate from '../pages/user/entry/UserCreate';
import UserUpdate from '../pages/user/entry/UserUpdate';
import GroupList from '../pages/group/view/GroupList';
import GroupCreate from '../pages/group/entry/GroupCreate';
import GroupUpdate from '../pages/group/entry/GroupUpdate';
import GroupDetail from '../pages/group/view/GroupDetail';
import BannerList from '../pages/banner/view/BannerList';
import BannerCreate from '../pages/banner/entry/BannerCreate';
import BannerUpdate from '../pages/banner/entry/BannerUpdate';
import BannerDetail from '../pages/banner/view/BannerDetail';
import LeagueList from '../pages/leaguecategory/view/LeagueList';
import LeagueCreate from '../pages/leaguecategory/entry/LeagueCreate';
import LeagueUpdate from '../pages/leaguecategory/entry/LeagueUpdate';
import LeagueDetail from '../pages/leaguecategory/view/LeagueDetail';
import TeamList from '../pages/team/view/TeamList';
import TeamCreate from '../pages/team/entry/TeamCreate';
import TeamUpdate from '../pages/team/entry/TeamUpdate';
import TeamDetail from '../pages/team/view/TeamDetail';
import NotiList from '../pages/noti/view/NotiList';
import LiveCategoryList from '../pages/livecategory/view/LiveCategoryList';
import LiveCategoryCreate from '../pages/livecategory/entry/LiveCategoryCreate';
import LiveCategoryUpdate from '../pages/livecategory/entry/LiveCategoryUpdate';
import LiveCategoryDetail from '../pages/livecategory/view/LiveCategoryDetail';
import HighLightCategoryList from '../pages/highlightcategory/view/HighLightCategoryList';
import HighlightCategoryCreate from '../pages/highlightcategory/entry/HighLightCategoryCreate';
import HighLightCategoryUpdate from '../pages/highlightcategory/entry/HighLightCategoryUpdate';
import HighLightCategoryDetail from '../pages/highlightcategory/view/HighLightCategoryDetail';
import LiveList from '../pages/live/view/LiveList';
import LiveCreate from '../pages/live/entry/LiveCreate';
import LiveUpdate from '../pages/live/entry/LiveUpdate';
import LiveDetail from '../pages/live/view/LiveDetail';
import HighLightList from '../pages/highlight/view/HighLightList';
import HighlightCreate from '../pages/highlight/entry/HighLightCreate';
import HighLightUpdate from '../pages/highlight/entry/HighLightUpdate';
import HighLightDetail from '../pages/highlight/view/HighLightDetail';
import TableList from '../pages/table/view/TableList';
import TableCreate from '../pages/table/entry/TableCreate';
import TableUpdate from '../pages/table/entry/TableUpdate';
import TipsList from '../pages/tips/view/TipsList';
import TipsCreate from '../pages/tips/entry/TipsCreate';
import TipsUpdate from '../pages/tips/entry/TipsUpdate';
import TipsDetail from '../pages/tips/view/TipsDetail';
import OddsList from '../pages/odds/view/OddsList';
import OddsCreate from '../pages/odds/entry/OddsCreate';
import OddsUpdate from '../pages/odds/entry/OddsUpdate';
// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: '/users/list',
      element: <UserList />
    },
    {
      path: '/users/create',
      element: <UserCreate />
    },
    {
      path: '/users/edit/:id',
      element: <UserUpdate />
    },
    {
      path: '/users/:id',
      element: <UserDetail />
    },
     {
      path: '/groups/list',
      element: <GroupList />
    },
    {
      path: '/groups/create',
      element: <GroupCreate />
    },
    {
      path: '/groups/update/:id',
      element: <GroupUpdate />
    },
    {
      path: '/groups/:id',
      element: <GroupDetail />
    },
    {
      path: '/banner/list',
      element: <BannerList />
    },
    {
      path: '/banner/create',
      element: <BannerCreate />
    },
    {
      path: '/banner/update/:id',
      element: <BannerUpdate />
    },
    {
      path: '/banner/:id',
      element: <BannerDetail />
    },

    {
      path: '/league/list',
      element: <LeagueList />
    },
    {
      path: '/league/create',
      element: <LeagueCreate />
    },
    {
      path: '/league/update/:id',
      element: <LeagueUpdate />
    },
    {
      path: '/league/:id',
      element: <LeagueDetail />
    },

    {
      path: '/team/list',
      element: <TeamList />
    },
    {
      path: '/team/create',
      element: <TeamCreate />
    },
    {
      path: '/team/update/:id',
      element: <TeamUpdate />
    },
    {
      path: '/team/:id',
      element: <TeamDetail />
    },

      {
      path: '/notifications/devices',
      element: <NotiList />
    },

     {
      path: '/livecategory/list',
      element: <LiveCategoryList />
    },
    {
      path: '/livecategory/create',
      element: <LiveCategoryCreate />
    },
    {
      path: '/livecategory/update/:id',
      element: <LiveCategoryUpdate />
    },
    {
      path: '/livecategory/:id',
      element: <LiveCategoryDetail />
    },

     {
      path: '/live/list',
      element: <LiveList />
    },
    {
      path: '/live/create',
      element: <LiveCreate />
    },
    {
      path: '/live/update/:id',
      element: <LiveUpdate />
    },
    {
      path: '/live/:id',
      element: <LiveDetail />
    },

    {
      path: '/highlightcategory/list',
      element: <HighLightCategoryList />
    },
    {
      path: '/highlightcategory/create',
      element: <HighlightCategoryCreate />
    },
    {
      path: '/highlightcategory/update/:id',
      element: <HighLightCategoryUpdate />
    },
    {
      path: '/highlightcategory/:id',
      element: <HighLightCategoryDetail />
    },

     {
      path: '/highlight/list',
      element: <HighLightList />
    },
    {
      path: '/highlight/create',
      element: <HighlightCreate />
    },
    {
      path: '/highlight/update/:id',
      element: <HighLightUpdate />
    },
    {
      path: '/highlight/:id',
      element: <HighLightDetail />
    },
    {
      path: '/table/list',
      element: <TableList />
    },
    {
      path: '/table/create',
      element: <TableCreate />
    },
    {
      path: '/table/update/:id',
      element: <TableUpdate />
    },
    {
      path: '/tips/list',
      element: <TipsList />
    },
    {
      path: '/tips/create',
      element: <TipsCreate />
    },
    {
      path: '/tips/update/:id',
      element: <TipsUpdate />
    },
    {
      path: '/tips/:id',
      element: <TipsDetail />
    },
    {
      path: '/odds/list',
      element: <OddsList />
    },
    {
      path: '/odds/create',
      element: <OddsCreate />
    },
    {
      path: '/odds/update/:id',
      element: <OddsUpdate />
    },

  ]
};

export default MainRoutes;
